import { Link } from "react-router-dom";
import img1 from "../../assets/Images/Dashboard-1.png"
import img2 from "../../assets/Images/Dashboard-2.png"
import img3 from "../../assets/Images/Dashboard-3.png"
import img4 from "../../assets/Images/Dashboard-4.png"
import DocNavigation from "../../components/DocNavigation";

export default function Dashboard() {
  return (
    <div className="space-y-16">

      {/* COMMON HERO */}
      <section className="bg-white rounded-xl border border-slate-200 p-10">
        <h1 className="text-2xl font-bold text-slate-900 mb-4">
          Dashboard
        </h1>
        <p className="text-md text-slate-600 max-w-3xl">
          The Dashboard is the control center of EventFlow. It provides a complete
          real-time overview of bookings, revenue, payments, and upcoming events.
        </p>
      </section>

      {/* WHAT THE DASHBOARD DOES */}
      <section className="grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div>
          <h2 className="text-xl font-semibold mb-4">
            What Is The EvenFlow Dashboard?
          </h2>
          <p className="text-slate-700 leading-relaxed">
            The EventFlow dashboard summarizes key operational and financial data so
            management can make informed decisions without navigating multiple
            modules.
          </p>
        </div>

        <div className="bg-[#C9A24E]/10 rounded-xl p-6">
          <h3 className="font-semibold mb-3">
            Key Goals
          </h3>
          <ul className="space-y-2 text-slate-700">
            <li>• Monitor bookings and revenue</li>
            <li>• Track pending and cancelled events</li>
            <li>• Identify outstanding dues</li>
            <li>• Prepare for upcoming events</li>
          </ul>
        </div>
      </section>

      {/* DATE FILTER */}
      <section className="bg-slate-100 rounded-xl p-10">
        <h2 className="text-xl font-semibold mb-4">
          Dashboard Date Filters
        </h2>

        <p className="text-slate-700 mb-6 max-w-4xl">
          Dashboard data is filtered using the <strong>Booking Date</strong>.
          The selected date range applies to all data except Upcoming Events,
          which always show future bookings.
        </p>

        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 text-slate-700">
          <li>• From Date – start of reporting period</li>
          <li>• To Date – end of reporting period</li>
          <li>• Default view shows current month</li>
          <li>• Upcoming Events are not date-filtered</li>
        </ul>
      </section>

      {/* KPI CARDS */}
      <section>
        <h2 className="text-xl font-semibold mb-6">
          Dashboard Summary Sections
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            ["Total Bookings", "Total number of bookings in selected period"],
            ["Online Bookings", "Bookings received via online channels"],
            ["Cancelled Bookings", "Total cancelled bookings"],
            ["Pending Shift Bookings", "Bookings without assigned dates"],
            ["Total Booking Amount", "Total value of all bookings"],
            ["Total Revenue", "Payments received in period"],
            ["Due Amount", "Outstanding payments"],
          ].map(([title, desc], i) => (
            <div key={i} className="bg-white border rounded-lg p-6">
              <h4 className="font-semibold mb-2">{title}</h4>
              <p className="text-sm text-slate-600">{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* UPCOMING EVENTS */}
      <section className="bg-slate-100 rounded-xl p-10">
        <h2 className="text-xl font-semibold mb-4">
          Upcoming Events
        </h2>

        <p className="text-slate-700 mb-6">
          Displays all future events regardless of selected date range, helping
          staff prepare in advance.
        </p>

        <ul className="space-y-2 text-slate-700">
          <li>• Client and event details</li>
          <li>• Event date, hall, and slot</li>
          <li>• Paid and due amounts</li>
        </ul>
      </section>

      {/* SCREENSHOTS */}
      <section>
        <h3 className="text-xl font-semibold mb-4">
          Dashboard Screens
        </h3>
        <div className="flex flex-col items-center justify-center space-y-16">
          <img src={img1} alt="" className="shadow-xl" />
          <img src={img2} alt="" />
          <img src={img3} alt="" />
          <img src={img4} alt="" />
        </div>

      </section>

      {/* DETAILED TABLES */}
      <section>
        <h2 className="text-xl font-semibold mb-6">
          Detailed Booking Tables
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            ["Completed Events with Pending Payments", "Completed events with remaining dues"],
            ["Current Month Bookings", "All bookings scheduled in current month"],
            ["Pending Shift Bookings", "Bookings without assigned event dates"],
            ["Cancelled Bookings", "Cancelled bookings with reasons"],
          ].map(([title, desc], i) => (
            <div key={i} className="bg-white border rounded-lg p-6">
              <h4 className="font-semibold mb-2">{title}</h4>
              <p className="text-sm text-slate-600">{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* NEXT */}
      {/* <section className="border-t pt-8 mt-12">
        <p className="text-slate-600">
          Next, learn how bookings are handled in{" "}
          <Link to="/docs/event-booking-management" className="font-medium text-[#C9A24E]">
            Event Booking Management
          </Link>.
        </p>
      </section> */}
     <DocNavigation
        previous={{
          title: "First Event Booking",
          link: "/docs/first-event-booking"
        }}
        next={{
          title: "Event Booking Management",
          link: "/docs/event-booking-management"
        }}
      />
    </div>
  );
}
